// page-schedule.jsx — 日程調整（Google カレンダー予約埋め込み）

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  // Google カレンダー予約スケジュール（issue#40追加: 川島さん入手の新予約リンクに差し替え 2026-06）
  const BOOKING_EMBED = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2k_etZgOhwva91STxg7K614yLRolbio7J6oKLnohgNFsFd30YmoOSEXyEOLiOAWY3oxkLseKBz?gv=true';
  const BOOKING_LINK  = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2k_etZgOhwva91STxg7K614yLRolbio7J6oKLnohgNFsFd30YmoOSEXyEOLiOAWY3oxkLseKBz';

  // 受け入れ条件（issue#40追加: 派遣先企業候補としてエントリーしたい企業様向け）
  const CONDITIONS = [
    '3名以上の受け入れをご希望であること',
    'クラウド会計人材の受け入れが可能であること',
    '経理人材の受け入れもご検討いただけること',
    '請負契約でのお取引となること',
    '3ヶ月以上の受け入れをご条件とすること',
  ];

  const DETAILS = [
    { k:'面談方法',   v:'オンライン（Google Meet）' },
    { k:'所要時間',   v:'30分' },
    { k:'費用',       v:'無料' },
    { k:'対応時間',   v:'平日 9:00〜18:00（ご要望があれば調整可能）' },
    { k:'対応エリア', v:'オンラインのため全国対応可能' },
  ];

  const FAQ = [
    { q:'どんな相談ができますか？', a:'バックオフィスのDX・会計／AX化・AI活用・採用・協業・営業など、事業に関わる内容であればどんなことでもお気軽にご相談ください。' },
    { q:'事前に準備するものはありますか？', a:'特にありません。現状の課題感をお伺いし、最適な進め方をご提案します。資料がある場合はお持ちいただくとより具体的なお話ができます。' },
    { q:'当日はどこに接続すればいいですか？', a:'ご予約確定後、Google Meet のリンクをメールでお送りします。当日はそのリンクからご参加ください。' },
    { q:'相談したら必ず契約しないといけませんか？', a:'いいえ。ご契約を急かすことは一切ありません。まずはお気軽にご相談ください。' },
    { q:'候補の日時が合いません。', a:'下部のお問い合わせフォームよりご連絡ください。個別に日程を調整いたします。' },
  ];

  function SchedulePage() {
    return (
      <HBLayout>
        <HBSubHero
          crumb={`Contact / 日程調整`}
          en="Schedule a Meeting"
          jp="日程調整はこちら"
          tag={'30分・オンライン・無料'}
          lead={'30分の無料オンライン相談をご用意しています。下のカレンダーからご都合のよい日時をお選びください。専門領域に応じて担当チームがお話を伺います。'}
        />

        {/* BOOKING — 予約カレンダー */}
        <section style={{padding:'72px 32px 40px', background:hbcp.white}}>
          <div style={{maxWidth:1080, margin:'0 auto'}}>
            <div style={{fontFamily:fontENSans, fontSize:11, fontWeight:500, letterSpacing:'.32em', color:hbcp.blue, marginBottom:10}}>● BOOKING</div>
            <h2 style={{fontFamily:fontJP, fontWeight:700, fontSize:26, letterSpacing:'.04em', margin:'0 0 28px'}}>面談の予約</h2>

            <div style={{display:'flex', flexWrap:'wrap', gap:0, border:`1px solid ${hbcp.line}`, marginBottom:36}}>
              {DETAILS.map((d,i) => (
                <div key={d.k} style={{flex:'1 1 200px', minWidth:180, padding:'18px 22px', borderRight:i<DETAILS.length-1?`1px solid ${hbcp.line}`:'none'}}>
                  <div style={{fontFamily:fontENSans, fontSize:10, fontWeight:600, letterSpacing:'.16em', color:hbcp.blue, marginBottom:7}}>{d.k}</div>
                  <div style={{fontFamily:fontJP, fontSize:14, lineHeight:1.6, color:hbcp.ink}}>{d.v}</div>
                </div>
              ))}
            </div>

            {/* 受け入れ条件（issue#40追加） */}
            <div style={{border:`1px solid ${hbcp.blue}`, background:hbcp.blueGhost || '#F4F8FD', padding:'26px 30px', marginBottom:36}}>
              <div style={{fontFamily:fontENSans, fontSize:10.5, fontWeight:600, letterSpacing:'.22em', color:hbcp.blue, marginBottom:10}}>FOR PARTNER COMPANIES</div>
              <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:17, margin:'0 0 10px'}}>人材受け入れ企業様向け：お打ち合わせの対象条件</h3>
              <p style={{fontSize:13.5, lineHeight:1.9, color:hbcp.inkSoft, margin:'0 0 16px'}}>
                本カレンダーからのお申し込みは、弊社の研修修了人材（クラウド会計人材・経理人材）の<strong style={{color:hbcp.ink}}>受け入れ企業候補としてエントリーをご希望の企業様</strong>を対象としています。以下の条件に合致する企業様向けにお打ち合わせが可能です。
              </p>
              <ul style={{margin:0, padding:0, listStyle:'none', display:'grid', gap:8}}>
                {CONDITIONS.map((c,i)=>(
                  <li key={i} style={{display:'flex', gap:10, alignItems:'baseline', fontSize:14, color:hbcp.ink, fontWeight:500}}>
                    <span style={{color:hbcp.blue, fontWeight:700, flex:'0 0 auto'}}>✓</span>{c}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{border:`1px solid ${hbcp.line}`, background:hbcp.paper}}>
              <iframe
                src={BOOKING_EMBED}
                title="日程調整カレンダー"
                style={{border:0, width:'100%', height:680, display:'block'}}
                frameBorder="0"
              />
            </div>
            <p style={{fontSize:13, lineHeight:1.9, color:hbcp.inkSoft, margin:'16px 0 0'}}>
              カレンダーが表示されない場合は{' '}
              <a href={BOOKING_LINK} target="_blank" rel="noopener noreferrer" style={{color:hbcp.blue, fontWeight:600}}>こちらの予約ページ ↗</a>
              {' '}から直接お申し込みいただけます。
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section style={{padding:'40px 32px 72px', background:hbcp.white}}>
          <div style={{maxWidth:880, margin:'0 auto'}}>
            <div style={{fontFamily:fontENSans, fontSize:11, fontWeight:500, letterSpacing:'.32em', color:hbcp.blue, marginBottom:10}}>● FAQ</div>
            <h2 style={{fontFamily:fontJP, fontWeight:700, fontSize:26, letterSpacing:'.04em', margin:'0 0 28px'}}>よくいただくご質問</h2>
            {FAQ.map((f,i) => (
              <article key={i} style={{padding:'22px 0', borderTop:`1px solid ${hbcp.line}`}}>
                <div style={{display:'flex', gap:14, alignItems:'baseline', marginBottom:8}}>
                  <span style={{fontFamily:fontEN, fontWeight:300, fontSize:20, color:hbcp.blue, lineHeight:1, minWidth:20}}>Q</span>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:17, lineHeight:1.5, margin:0}}>{f.q}</h3>
                </div>
                <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 0 34px'}}>{f.a}</p>
              </article>
            ))}
          </div>
        </section>

        {/* CONTACT フォールバック */}
        <section style={{padding:'64px 32px', background:hbcp.paper}}>
          <div style={{maxWidth:880, margin:'0 auto', textAlign:'center'}}>
            <div style={{fontFamily:fontENSans, fontSize:11, fontWeight:500, letterSpacing:'.32em', color:hbcp.blue, marginBottom:14}}>● CONTACT</div>
            <h2 style={{fontFamily:fontJP, fontWeight:700, fontSize:22, letterSpacing:'.04em', margin:'0 0 14px'}}>お問い合わせフォームもご利用いただけます</h2>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 28px'}}>
              日程の候補が合わない場合や、まずはメールでご相談されたい方はお問い合わせフォームをご利用ください。通常 2 営業日以内にご返信いたします。
            </p>
            <a href={`${HB_BASE}/contact`} style={{display:'inline-flex', alignItems:'center', gap:8, fontFamily:fontJP, fontWeight:700, fontSize:15, color:'#fff', background:hbcp.blue, textDecoration:'none', padding:'15px 32px'}}>
              お問い合わせフォームへ <span style={{fontFamily:fontEN}}>↗</span>
            </a>
          </div>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { SchedulePage });
})();
